module.exports = __webpack_public_path__ + "img/图.b0047a54.webp";